// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `



.SubMenu_sidebarLink__ij4K- {
  display: flex;
  color: #260944;
  justify-content: space-between;
  align-items: center;
  padding: 9px 20px;
  text-decoration: none;
  font-size: 14.5px;
  border-radius: 5px;
  font-weight: 500;
  margin-top: 3px;
  margin-bottom: 3px;
  
  

}
.SubMenu_sidebarLink__ij4K- svg {
  fill: #c1c1c1;
  position: relative;
  top: 2px;
}
.SubMenu_sidebarLink__ij4K-:hover {
  background: linear-gradient(225deg,  var(--gradientColor1) 0%, var(--gradientColor2) 91.25%);
  text-decoration: none;
  color: #fff;
}
.SubMenu_sidebarLink2__VNYgL {
  display: block;
  color: #5B5B98;
  justify-content: space-between;
  align-items: center;
  padding: 9px 20px 9px 50px;
  text-decoration: none;
  font-size: 14px;
  border-radius: 5px;
  font-weight: 500;
  position: relative;
  margin-top: .2rem;
}
.SubMenu_sidebarLink2__VNYgL::before {
  content: "";
  background-color: #818093;
  width: 6px;
  height: 6px;
  border-radius: 100%;
  position: absolute;
  left: 30px;
  top: 16px;
}
.SubMenu_sidebarLink2__VNYgL:hover::before {
  background-color: var(--themeFontColor);
}
.SubMenu_sidebarLink2__VNYgL:hover {
  background: linear-gradient(225deg,  var(--gradientColor1) 0%, var(--gradientColor2) 91.25%);
  color: #fff;
}

/* For RTL Style */
[dir=rtl] .SubMenu_sidebarLink2__VNYgL {
  padding: 9px 50px 9px 20px;
}
[dir=rtl] .SubMenu_sidebarLink2__VNYgL::before {
  left: auto;
  right: 30px;
}

/* For dark mode */
[class="dark"] .SubMenu_sidebarLink__ij4K-, [class="leftsidebardark"] .SubMenu_sidebarLink__ij4K- {
  color: #f3f3f3;
}
[class="dark"] .SubMenu_sidebarLink__ij4K- svg, [class="leftsidebardark"] .SubMenu_sidebarLink__ij4K- svg {
  fill: #f3f3f3;
}
[class="dark"] .SubMenu_sidebarLink__ij4K- span, [class="leftsidebardark"] .SubMenu_sidebarLink__ij4K- svg {
  color: #f3f3f3;
}
[class="dark"] .SubMenu_sidebarLink__ij4K-:hover, [class="leftsidebardark"] .SubMenu_sidebarLink__ij4K- svg {
  color: var(--themeFontColor);
}
[class="dark"] .SubMenu_sidebarLink__ij4K-:hover span, [class="leftsidebardark"] .SubMenu_sidebarLink__ij4K- svg {
  color: var(--themeFontColor);
}
[class="dark"] .SubMenu_sidebarLink__ij4K-:hover svg, [class="leftsidebardark"] .SubMenu_sidebarLink__ij4K- svg {
  fill: var(--themeFontColor);
}

[class="dark"] .SubMenu_sidebarLink2__VNYgL, [class="leftsidebardark"] .SubMenu_sidebarLink2__VNYgL {
  color: var(--darkHeadingTextColor);
}
[class="dark"] .SubMenu_sidebarLink2__VNYgL span, [class="leftsidebardark"] .SubMenu_sidebarLink2__VNYgL {
  color: var(--darkHeadingTextColor);
}
[class="dark"] .SubMenu_sidebarLink2__VNYgL:hover, [class="leftsidebardark"] .SubMenu_sidebarLink2__VNYgL {
  color: var(--themeFontColor);
}
[class="dark"] .SubMenu_sidebarLink2__VNYgL:hover span, [class="leftsidebardark"] .SubMenu_sidebarLink2__VNYgL {
  color: var(--themeFontColor);
}`, "",{"version":3,"sources":["webpack://./src/components/Layout/LeftSidebar/SubMenu.module.css"],"names":[],"mappings":";;;;AAIA;EACE,aAAa;EACb,cAAc;EACd,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;;;;AAIpB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,4FAA4F;EAC5F,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,cAAc;EACd,cAAc;EACd,8BAA8B;EAC9B,mBAAmB;EACnB,0BAA0B;EAC1B,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;AACA;EACE,uCAAuC;AACzC;AACA;EACE,4FAA4F;EAC5F,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,0BAA0B;AAC5B;AACA;EACE,UAAU;EACV,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B","sourcesContent":["\n\n\n\n.sidebarLink {\n  display: flex;\n  color: #260944;\n  justify-content: space-between;\n  align-items: center;\n  padding: 9px 20px;\n  text-decoration: none;\n  font-size: 14.5px;\n  border-radius: 5px;\n  font-weight: 500;\n  margin-top: 3px;\n  margin-bottom: 3px;\n  \n  \n\n}\n.sidebarLink svg {\n  fill: #c1c1c1;\n  position: relative;\n  top: 2px;\n}\n.sidebarLink:hover {\n  background: linear-gradient(225deg,  var(--gradientColor1) 0%, var(--gradientColor2) 91.25%);\n  text-decoration: none;\n  color: #fff;\n}\n.sidebarLink2 {\n  display: block;\n  color: #5B5B98;\n  justify-content: space-between;\n  align-items: center;\n  padding: 9px 20px 9px 50px;\n  text-decoration: none;\n  font-size: 14px;\n  border-radius: 5px;\n  font-weight: 500;\n  position: relative;\n  margin-top: .2rem;\n}\n.sidebarLink2::before {\n  content: \"\";\n  background-color: #818093;\n  width: 6px;\n  height: 6px;\n  border-radius: 100%;\n  position: absolute;\n  left: 30px;\n  top: 16px;\n}\n.sidebarLink2:hover::before {\n  background-color: var(--themeFontColor);\n}\n.sidebarLink2:hover {\n  background: linear-gradient(225deg,  var(--gradientColor1) 0%, var(--gradientColor2) 91.25%);\n  color: #fff;\n}\n\n/* For RTL Style */\n[dir=rtl] .sidebarLink2 {\n  padding: 9px 50px 9px 20px;\n}\n[dir=rtl] .sidebarLink2::before {\n  left: auto;\n  right: 30px;\n}\n\n/* For dark mode */\n[class=\"dark\"] .sidebarLink, [class=\"leftsidebardark\"] .sidebarLink {\n  color: #f3f3f3;\n}\n[class=\"dark\"] .sidebarLink svg, [class=\"leftsidebardark\"] .sidebarLink svg {\n  fill: #f3f3f3;\n}\n[class=\"dark\"] .sidebarLink span, [class=\"leftsidebardark\"] .sidebarLink svg {\n  color: #f3f3f3;\n}\n[class=\"dark\"] .sidebarLink:hover, [class=\"leftsidebardark\"] .sidebarLink svg {\n  color: var(--themeFontColor);\n}\n[class=\"dark\"] .sidebarLink:hover span, [class=\"leftsidebardark\"] .sidebarLink svg {\n  color: var(--themeFontColor);\n}\n[class=\"dark\"] .sidebarLink:hover svg, [class=\"leftsidebardark\"] .sidebarLink svg {\n  fill: var(--themeFontColor);\n}\n\n[class=\"dark\"] .sidebarLink2, [class=\"leftsidebardark\"] .sidebarLink2 {\n  color: var(--darkHeadingTextColor);\n}\n[class=\"dark\"] .sidebarLink2 span, [class=\"leftsidebardark\"] .sidebarLink2 {\n  color: var(--darkHeadingTextColor);\n}\n[class=\"dark\"] .sidebarLink2:hover, [class=\"leftsidebardark\"] .sidebarLink2 {\n  color: var(--themeFontColor);\n}\n[class=\"dark\"] .sidebarLink2:hover span, [class=\"leftsidebardark\"] .sidebarLink2 {\n  color: var(--themeFontColor);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebarLink": `SubMenu_sidebarLink__ij4K-`,
	"sidebarLink2": `SubMenu_sidebarLink2__VNYgL`
};
export default ___CSS_LOADER_EXPORT___;
